// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/actions.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { EmailThreadWithMessages } from "./emails_pb";
import { file_cortado_v1_emails } from "./emails_pb";
import type { ActivityTypeEnum, ActorTypeEnum, ParentTypeEnum, TaskStatusEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/actions.proto.
 */
export const file_cortado_v1_actions: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_cortado_v1_emails, file_cortado_v1_settings, file_cortado_v1_users]);

/**
 * Note represents a note attached to an entity
 *
 * @generated from message cortado.v1.Note
 */
export type Note = Message<"cortado.v1.Note"> & {
  /**
   * Unique identifier for the note
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the note belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Type of parent entity
   *
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 3;
   */
  parentType: ParentTypeEnum;

  /**
   * ID of parent entity
   *
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * Note content
   *
   * @generated from field: string note = 5;
   */
  note: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 9;
   */
  updatedBy: string;

  /**
   * Embedded full objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * Parent entity display name (denormalized for performance)
   *
   * @generated from field: optional string parent_name = 22;
   */
  parentName?: string;

  /**
   * @generated from field: optional string job_id = 23;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.Note.
 * Use `create(NoteSchema)` to create a new message.
 */
export const NoteSchema: GenMessage<Note> = /*@__PURE__*/
  messageDesc(file_cortado_v1_actions, 0);

/**
 * Task represents a task in the system
 *
 * @generated from message cortado.v1.Task
 */
export type Task = Message<"cortado.v1.Task"> & {
  /**
   * Unique identifier for the task
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the task belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Type of parent entity
   *
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 3;
   */
  parentType: ParentTypeEnum;

  /**
   * ID of parent entity
   *
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * User ID the task is assigned to
   *
   * @generated from field: string assigned_to = 5;
   */
  assignedTo: string;

  /**
   * Due date for the task
   *
   * @generated from field: google.protobuf.Timestamp due_date = 6;
   */
  dueDate?: Timestamp;

  /**
   * Status of the task
   *
   * @generated from field: cortado.v1.TaskStatusEnum task_status = 7;
   */
  taskStatus: TaskStatusEnum;

  /**
   * Title of the task
   *
   * @generated from field: string title = 8;
   */
  title: string;

  /**
   * Description of the task
   *
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * Enriched fields for dashboard/list views (optional)
   * Full user object for the assigned_to user
   *
   * @generated from field: optional cortado.v1.User assigned_to_user = 14;
   */
  assignedToUser?: User;

  /**
   * Full user object for the created_by user
   *
   * @generated from field: optional cortado.v1.User created_by_user = 15;
   */
  createdByUser?: User;

  /**
   * Full user object for the updated_by user
   *
   * @generated from field: optional cortado.v1.User updated_by_user = 16;
   */
  updatedByUser?: User;

  /**
   * @generated from field: optional string job_id = 17;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.Task.
 * Use `create(TaskSchema)` to create a new message.
 */
export const TaskSchema: GenMessage<Task> = /*@__PURE__*/
  messageDesc(file_cortado_v1_actions, 1);

/**
 * TaskLite is a lightweight task representation for list views
 * Contains only essential display fields to minimize payload size
 *
 * @generated from message cortado.v1.TaskLite
 */
export type TaskLite = Message<"cortado.v1.TaskLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.ParentTypeEnum parent_type = 3;
   */
  parentType: ParentTypeEnum;

  /**
   * @generated from field: string parent_id = 4;
   */
  parentId: string;

  /**
   * Task details
   *
   * @generated from field: string title = 10;
   */
  title: string;

  /**
   * @generated from field: string description = 11;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 12;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: cortado.v1.TaskStatusEnum task_status = 13;
   */
  taskStatus: TaskStatusEnum;

  /**
   * Assignee summary (denormalized for performance)
   *
   * @generated from field: string assigned_to = 20;
   */
  assignedTo: string;

  /**
   * @generated from field: string assigned_to_first_name = 21;
   */
  assignedToFirstName: string;

  /**
   * @generated from field: string assigned_to_last_name = 22;
   */
  assignedToLastName: string;

  /**
   * Created by summary (denormalized for performance)
   *
   * @generated from field: string created_by = 30;
   */
  createdBy: string;

  /**
   * @generated from field: string created_by_first_name = 31;
   */
  createdByFirstName: string;

  /**
   * @generated from field: string created_by_last_name = 32;
   */
  createdByLastName: string;

  /**
   * Parent entity display name (denormalized for performance)
   *
   * @generated from field: optional string parent_name = 5;
   */
  parentName?: string;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 40;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 41;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string job_id = 42;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.TaskLite.
 * Use `create(TaskLiteSchema)` to create a new message.
 */
export const TaskLiteSchema: GenMessage<TaskLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_actions, 2);

/**
 * Activity represents an activity in the activity feed
 *
 * @generated from message cortado.v1.Activity
 */
export type Activity = Message<"cortado.v1.Activity"> & {
  /**
   * Unique identifier for the activity
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the activity belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Activity classification
   *
   * @generated from field: cortado.v1.ActivityTypeEnum activity_type = 3;
   */
  activityType: ActivityTypeEnum;

  /**
   * Who triggered the activity
   *
   * User or contact ID (null for system)
   *
   * @generated from field: optional string actor_id = 4;
   */
  actorId?: string;

  /**
   * @generated from field: cortado.v1.ActorTypeEnum actor_type = 5;
   */
  actorType: ActorTypeEnum;

  /**
   * What entity is this activity about
   *
   * 'inquiry', 'quote', 'invoice', etc.
   *
   * @generated from field: string entity_type = 6;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 7;
   */
  entityId: string;

  /**
   * Human-readable content
   *
   * @generated from field: string title = 8;
   */
  title: string;

  /**
   * @generated from field: optional string description = 9;
   */
  description?: string;

  /**
   * Related contact for quick navigation
   *
   * @generated from field: optional string contact_id = 10;
   */
  contactId?: string;

  /**
   * Extra metadata as JSON string for flexibility
   * Examples: { "old_stage": "NEW", "new_stage": "IN_PROGRESS" }
   *           { "amount_cents": 50000, "payment_method": "card" }
   *
   * @generated from field: optional string metadata = 11;
   */
  metadata?: string;

  /**
   * @generated from field: optional string job_id = 12;
   */
  jobId?: string;

  /**
   * Timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * Embedded objects for display (optional, populated based on context)
   *
   * @generated from field: optional cortado.v1.User actor_user = 30;
   */
  actorUser?: User;
};

/**
 * Describes the message cortado.v1.Activity.
 * Use `create(ActivitySchema)` to create a new message.
 */
export const ActivitySchema: GenMessage<Activity> = /*@__PURE__*/
  messageDesc(file_cortado_v1_actions, 3);

/**
 * ActivityLite is a lightweight activity representation for the feed
 * Contains essential display fields with denormalized data
 *
 * @generated from message cortado.v1.ActivityLite
 */
export type ActivityLite = Message<"cortado.v1.ActivityLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Activity classification
   *
   * @generated from field: cortado.v1.ActivityTypeEnum activity_type = 3;
   */
  activityType: ActivityTypeEnum;

  /**
   * Actor summary (denormalized for performance)
   *
   * @generated from field: optional string actor_id = 4;
   */
  actorId?: string;

  /**
   * @generated from field: cortado.v1.ActorTypeEnum actor_type = 5;
   */
  actorType: ActorTypeEnum;

  /**
   * Denormalized: user full name or contact name
   *
   * @generated from field: optional string actor_name = 6;
   */
  actorName?: string;

  /**
   * Entity reference
   *
   * @generated from field: string entity_type = 10;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 11;
   */
  entityId: string;

  /**
   * @generated from field: optional string job_id = 12;
   */
  jobId?: string;

  /**
   * Human-readable content
   *
   * @generated from field: string title = 20;
   */
  title: string;

  /**
   * @generated from field: optional string description = 21;
   */
  description?: string;

  /**
   * Related contact summary (denormalized)
   *
   * @generated from field: optional string contact_id = 30;
   */
  contactId?: string;

  /**
   * Denormalized: contact full name
   *
   * @generated from field: optional string contact_name = 31;
   */
  contactName?: string;

  /**
   * Metadata as JSON string
   *
   * @generated from field: optional string metadata = 40;
   */
  metadata?: string;

  /**
   * Timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 50;
   */
  createdAt?: Timestamp;

  /**
   * Threaded email context for email feed rows (optional)
   *
   * @generated from field: optional cortado.v1.EmailThreadWithMessages email_thread = 60;
   */
  emailThread?: EmailThreadWithMessages;
};

/**
 * Describes the message cortado.v1.ActivityLite.
 * Use `create(ActivityLiteSchema)` to create a new message.
 */
export const ActivityLiteSchema: GenMessage<ActivityLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_actions, 4);

